export const BRAND_ASSETS = {
  bagFront: "https://customer-assets.emergentagent.com/job_elle-experience/artifacts/d5thdltn_Untitled-1.png",
  bagBack: "https://customer-assets.emergentagent.com/job_elle-experience/artifacts/tdsilg4v_Untitled-2.png",
  patternA: "https://customer-assets.emergentagent.com/job_elle-experience/artifacts/beh1svu9_Untitled-3.png",
  patternB: "https://customer-assets.emergentagent.com/job_elle-experience/artifacts/5jgb1itj_Untitled-4.png",
};

export const PHOTOGRAPHY = {
  landscape:
    "https://images.unsplash.com/photo-1637588168506-be08391079e4?crop=entropy&cs=srgb&fm=jpg&q=85",
  cherries:
    "https://images.unsplash.com/photo-1765990604870-fffd6d5f3961?crop=entropy&cs=srgb&fm=jpg&q=85",
  beans:
    "https://images.unsplash.com/photo-1674141867691-eb58e17e0a5e?crop=entropy&cs=srgb&fm=jpg&q=85",
  ceremony:
    "https://images.unsplash.com/photo-1630861413071-a424a4d6d155?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const BUSINESS_INFO = {
  email: "hello@ellecoffee.com",
  location: "Sidama, Ethiopia — Worldwide shipping",
  hours: "Mon – Sat · 9:00 – 18:00 EAT",
  instagram: "https://instagram.com/ellecoffee",
  twitter: "https://twitter.com/ellecoffee",
  facebook: "https://facebook.com/ellecoffee",
  tiktok: "https://tiktok.com/@ellecoffee",
};
